import { z } from 'zod';
export const tokenParamSchema = z.object({ token: z.string().min(1) });
/**
 * The app's second unauthenticated account-creation path, after
 * `applicantSignUpSchema` — see `POST /api/portal-invites/:token/redeem`
 * (modules/portal-invites/routes.ts). Password bounds match
 * `applicantSignUpSchema` and `lib/auth.ts`'s configured
 * min/maxPasswordLength. Deliberately no `name` field: the recipient's
 * display name comes from the owner/tenant record the invite was issued
 * against, not re-typed here.
 */
export const redeemPortalInviteSchema = z.object({
    password: z.string().min(12).max(512),
});
//# sourceMappingURL=portal-invites.js.map